import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestimonialsService {

  constructor(private crudService: CrudService) { }

  Save(model: any): Observable<any> {
    debugger;
    return this.crudService.post<any>('api/Testimonials/Save', model);
  }
}
